module.exports = __webpack_public_path__ + "static/media/Apple Watch 42mm Edition Open.d4c5277c.png";